<template>
  <div>
    <div v-if="datas" class="mcontainer">
      <div class="mleft">
        <div class="mcard" data-test="task-card">
          <div class="mcard--title">
            {{ $t("organization.dashboard.task-title") }}
            <span>
              {{ $t("task.completed") }}
              {{ datas.tasks.total }}/{{ datas.tasks.completedCount }}</span
            >
          </div>
          <hr />
          <div>
            <div>
              <doughnut-chart :backgroundColors="taskStatusDataSet.colors" :labels="taskStatusDataSet.labels" :datas="taskStatusDataSet.datas" @click="goToTaskList" />
              <div class="chart-label">{{ $t("organization.dashboard.task-status-info") }}</div>
            </div>
          </div>
        </div>

        <!-- TKP-149 / tasarım s.35 md.1 (karar 2026-09-27): tedbir ve soru seti kartları yerine modül başına onay + teyit özeti;
             yalnız kullanıcının kapsamında görebileceği modüller (matris A/E) -->
        <div v-for="card in complianceCards" :key="card.product" class="mcard mcard--compact" :data-test="`compliance-${card.product}`">
          <div class="mcard--title">
            {{ card.title }}
            <span class="hand" @click="go(card.link)">{{ $t("organization.dashboard.go-module") }}</span>
          </div>
          <hr />
          <small v-if="card.scoped" class="text-muted d-block mb-2">{{ $t("organization.dashboard.scoped") }}</small>
          <div v-for="row in card.rows" :key="row.key" class="d-flex justify-content-between align-items-center mb-2" :data-test="`row-${row.key}`">
            <span class="text-muted">{{ row.label }}</span>
            <b-badge v-if="row.link" :variant="row.warn ? 'warning' : 'light'" class="hand" @click="go(row.link)">{{ row.value }}</b-badge>
            <span v-else class="font-weight-bold">{{ row.value }}</span>
          </div>
        </div>
      </div>
      <div class="mcalendar-card">
        <div class="mcard--title mx-4 pt-2">
          <div class="col-md-6">
            {{ $t("organization.dashboard.calendar") }}
            <label class="mcard--subtitle">{{ datas.tasks.unCompletedCount }} {{ $t("task.active") }}</label>
          </div>
          <div class="col-md-6">
            <span @click="changeRouter('/tasks', 'list', undefined, 'organization')" class="float-right hand mt-4"> {{ $t("task.view-list") }}</span>
          </div>
        </div>
        <hr style="margin-top: 0;" />
        <full-calendar :events="calendarEvents" />
      </div>
    </div>
  </div>
</template>

<script>
import DoughnutChart from "./components/doughnut";
import { dateToStr } from "./components/event-utils";
import FullCalendar from "./components/fullcalendar";
import { complianceCards, taskStatusChart } from "./dashboard-summary";
import { resolveStatuses } from "@/modules/task/task-settings";

export default {
  components: { FullCalendar, DoughnutChart },
  computed: {
    datas() {
      return this.$store.getters["organization/dashboard"];
    },
    language() {
      return this.$store.getters["user/account"]?.language ?? "tr";
    },
    // TKP-119/149: grafik etiketleri ve renkleri organizasyonun durum kayıtlarından (özel durumlar dahil)
    taskStatusDataSet() {
      if (!this.datas?.tasks) return { keys: [], labels: [], datas: [], colors: [] };
      const statuses = resolveStatuses(this.$store.getters["taskSettings/statuses"], this.language, (k) => this.$t(k));
      return taskStatusChart(this.datas.tasks.tasksByStatus, statuses);
    },
    complianceCards() {
      return complianceCards(this.datas?.compliance, (k, p) => this.$t(k, p));
    },
    calendarEvents() {
      if (!this.datas) return [];
      return (this.datas.tasks.events || []).map((i) => ({ ...i, start: dateToStr(new Date(i.start)) }));
    },
  },
  mounted() {
    this.$store.dispatch("organization/dashboard");
    this.$store.dispatch("taskSettings/ensure").catch(() => undefined);
  },
  methods: {
    go(path) {
      this.$router.push(path);
    },
    changeRouter(path, viewType, status, activeTab) {
      this.$router.push({
        path,
        query: {
          ...(viewType ? { viewType } : {}),
          ...(status ? { status } : {}),
          ...(activeTab ? { activeTab } : {}),
        },
      });
    },
    goToTaskList(event, elements) {
      const clickedIndex = elements?.[0]?.index;
      const status = this.taskStatusDataSet.keys[clickedIndex];
      if (status) this.changeRouter("/tasks", "list", status, "organization");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./dashboard";
.mcard--compact {
  min-height: auto;
}
</style>
